import { Menu } from '@zorro/design-system/v2/Menu';
import { ElementType, ReactNode } from 'react';

type ActionsSubMenuProps = {
  title: string;
  icon?: ElementType;
  children: ReactNode;
};

const ActionsSubMenu = ({
  title,
  icon: Icon,
  children,
}: ActionsSubMenuProps) => {
  return (
    <Menu.Sub>
      <Menu.Sub.Target>
        <Menu.Sub.Item leftSection={Icon && <Icon size={16} stroke={1.25} />}>
          {title}
        </Menu.Sub.Item>
      </Menu.Sub.Target>
      <Menu.Sub.Dropdown>{children}</Menu.Sub.Dropdown>
    </Menu.Sub>
  );
};

export { ActionsSubMenu };
